import moment from "moment";
import { getUsuario } from "@/utils/auth";
const usuario = getUsuario();
import CONFIG from "./config";

export const TYPECATALOG = {
  noespecificado: "0",
  estadocivil: "1",
  sexo: "2",
  tipodocumento: "3",
  clasificacionpredio: "4",
  condicionnumeracionpuerta: "5",
  condicionconductor: "6",
  condiciondeclarante: "7",
  caracteristicatitularidad: "8",
  condicionespecialpredio: "9",
  condicionespecialtitular: "10",
  declaratoriafabrica: "11",
  documentopresentadofichaeconomica: "12",
  estadoconservacion: "13",
  estadoconstruccion: "14",
  estadollenadoficha: "15",
  evaluacionprediocatastral: "16",
  formaadquisicionpredio: "17",
  mantenimientofichabiencomun: "18",
  mantenimientofichaeconomica: "19",
  mantenimientofichaindividual: "20",
  materialestructurapredominante: "21",
  predioen: "22",
  tipoanuncio: "23",
  tipodocumentoconstruccion: "24",
  tipoedificacion: "25",
  tipoficha: "26",
  tipohabilitacionurbana: "27",
  tipointeriorpredio: "28",
  tipopartidaregistral: "29",
  tipopersona: "30",
  tipopersonajuridica: "31",
  tipopuerta: "32",
  tipovia: "33",
  unidadconstruccionantirregla: "34",
  tipopersonal: "35",
  grupohabilitacionurbana: "36",
  tipozona: "37",
  ubicacion: "38",
  inscripcionregistropublico: "39",
  documentosobrepropiedad: "40",
  tipodocumentoprueba: "41",
  tipoconstruccioninstalacion: "42",
  materialestructurapredominanterural: "43",
  estadoconservacionrural: "44",
  estadoconstruccionrural: "45",
  codigouso: "46",
  clasificacionusoactual: "47",
  tiporazaespecie: "48",
  riego: "49",
  fuentehidrica: "50",
  cercaniariocarretera: "51",
  categoriainmueble: "52",
  areamonumento: "53",
  filiacioncronologica: "54",
  presenciaarquitectura: "55",
  tipoarquitectura: "56",
  tipomaterialconstructivo: "57",
  afectacionnatural: "58",
  afectacionantropica: "59",
  intervencionconservacion: "60",
  tipopartidaregistralbiencultural: "61",
  inmubledeclaradopatrimonio: "62",
  tipocalendarioconstruccion: "63",
  tipoarquitecturahistorica: "64",
  tipoidentificacionelemento: "65",
  filiacionestilistica: "66",
  estadoelemento: "67",
  estructuraacabado: "68",
  intervencioninmueble: "69",
  tipocultivorural: "70",
  gruporural: "71",
  claserural: "72",
  derechousoagua: "73",
  especialtitularrural: "74"
};

export const CODIGOS_ACCIONES = [
  { id: 1, nombre: "Insertar" },
  { id: 2, nombre: "Editar" },
  { id: 3, nombre: "Eliminar" },
  { id: 4, nombre: "Refrescar" },
  { id: 5, nombre: "Visualizar" },
  { id: 6, nombre: "Exportar" },
  { id: 7, nombre: "Buscar" },
  { id: 8, nombre: "Filtrar" },
  { id: 9, nombre: "Activar" },
  { id: 10, nombre: "Subir Archivo" }
];

export const SYSTEM = {
  id: 3,
  title: CONFIG.NOMBRE_SISTEMA,
  subtitle: `${CONFIG.NOMBRE_SISTEMA} - ${CONFIG.SIGLA_CLIENTE}`,
  description: `${CONFIG.NOMBRE_SISTEMA} | ${CONFIG.NOMBRE_CLIENTE}`,
  abbreviation: CONFIG.AREA_CLIENTE,
  colour: {
    primary: CONFIG.COLOR_PRIMARY
  }
};

export const PRINT = {
  title: `${CONFIG.NOMBRE_SISTEMA} | ${CONFIG.NOMBRE_CLIENTE}`,
  subtitle: CONFIG.NOMBRE_CLIENTE,
  poptitle: CONFIG.AREA_CLIENTE,
  printedby: "Impreso por el usuario " + usuario?.SESSION_NOMBRE,
  datequery: "Consultado el " + moment().format("llll"),
  logosolo: require("@/assets/local/logo_solo.png"),
  logoleft: require("@/assets/local/logo.png"),
  logoright: require("@/assets/local/logo_secundario.png")
};

export const institucion = {
  ubigeo: CONFIG.UBIGEO,
  departamento: CONFIG.CODIGO_DEPARTAMENTO,
  provincia: CONFIG.CODIGO_PROVINCIA,
  labelDepartamento: CONFIG.NOMBRE_DEPARTAMENTO,
  labelProvincia: CONFIG.NOMBRE_PROVINCIA,
  labelUbigeo: CONFIG.NOMBRE_UBIGEO
};

export const typefichapath = {
  individual: "ficha-individual",
  cotitularidad: "ficha-cotitularidad",
  actividadeconomica: "ficha-economica",
  biencomun: "ficha-biencomun",
  biencultural: "ficha-biencultural",
  rural: "ficha-rural"
};

export const typefichapathnf = {
  individual: "ficha-individual-nf",
  cotitularidad: "ficha-cotitularidad-nf",
  actividadeconomica: "ficha-economica-nf",
  biencomun: "ficha-biencomun-nf",
  biencultural: "ficha-biencultural-nf",
  rural: "ficha-rural-nf"
};

export const objficha = {
  individual: {
    name: "individual",
    code: "215",
    path: "ficha-individual",
    pathnf: "ficha-individual-nf",
    table: "cat_fichaindividual",
    item: "observacion",
    numeration: true
  },
  cotitularidad: {
    name: "cotitularidad",
    code: "216",
    path: "ficha-cotitularidad",
    pathnf: "ficha-cotitularidad-nf",
    table: "cat_fichacotitularidad",
    item: "observacion",
    numeration: true
  },
  economica: {
    name: "economica",
    code: "217",
    path: "ficha-economica",
    pathnf: "ficha-economica-nf",
    table: "cat_fichaeconomica",
    item: "observacion",
    numeration: true
  },
  biencomun: {
    name: "biencomun",
    code: "218",
    path: "ficha-biencomun",
    pathnf: "ficha-biencomun-nf",
    table: "cat_fichabiencomun",
    item: "observacion",
    numeration: true
  },
  biencultural: {
    name: "biencultural",
    code: "219",
    path: "ficha-biencultural",
    pathnf: "ficha-biencultural-nf",
    table: "cat_fichabiencultural",
    item: "observacion",
    numeration: true
  },
  biencultural_historico: {
    name: "biencultural",
    code: "219",
    path: "ficha-biencultural",
    pathnf: "ficha-biencultural-nf",
    table: "cat_fichabiencultural",
    item: "observacionhistorico",
    numeration: true
  },
  rural: {
    name: "rural",
    code: "220",
    path: "ficha-rural",
    pathnf: "ficha-rural-nf",
    table: "cat_ficharural",
    item: "observacion",
    numeration: false
  },
  cotitularidadrural: {
    name: "cotitularidadrural",
    code: "571",
    path: "ficha-cotitularidad-rural",
    pathnf: "ficha-cotitularidad-rural-nf",
    table: "cat_fichacotitularidadrural",
    item: "observacion",
    numeration: false
  }
};

export const typeformalization = {
  formalizado: 1,
  noformalizado: 2
};

export const PATH = {
  API_SERVICE: "/v1/service",
  API_DOWNLOAD: "/v1/service/downloadCSV",
  API_VALIDAR: "/v1/service/verify",
  API_PROCESAR: "/v1/service/procesar",
  API_OBTENER_PUNTOS: "/v1/service/obtener-puntos",
  API_GEOSERVER_BUSCAR: "/v1/ServiceGeoserver/buscar",
  API_GEOSERVER_PROCESAR_COORDENADAS: "/v1/ServiceGeoserver/procesarCoordenadas"
};

export const forgotPassword = {
  text: "Olvidé mi contraseña",
  titulo: "CATASTRO",
  logo: require("@/assets/local/logo.png"),
  buttonText: "RECUPERAR CONTRASEÑA",
  goLogin: "IR A INICIAR SESIÓN",
  pathLogin: "login"
};

export const recover = {
  text: "Restablecer contraseña",
  titulo: "SISTEMA DE CATASTRO",
  logo: require("@/assets/local/logo.png"),
  buttonText: "RESTABLECER CONTRASEÑA",
  goLogin: "IR A INICIAR SESIÓN",
  pathLogin: "login"
};

export const OTHER = {
  estado: 5,
  documentoregistro: 16,
  documentoruc: 570,
  tipozona: 31,
  tipovia: 45,
  tipobeneficiario: 67,
  tipodocumentoinscripcion: 82,
  entidadjuridica: 265,
  documentodni: 9,
  tipopersonajuridica: 270,
  condiciondeclarante: 52,
};

export const typeficha = {
  individual: "215",
  cotitularidad: "216",
  actividadeconomica: "217",
  biencomun: "218",
  biencultural: "219",
  rural: "220",
  cotitularidadrural: "571"
};

export const PERSONA_NATURAL = 264;
export const PERSONA_JURIDICA = 265;

export const IS_UPERCASE = true; // true, false, null

export const ID_TIPO_DOCUMENTO_DNI = "9";
export const OTRO_TIPO_DOCUMENTO_REGISTRO = "16";
export const OTRO_TIPO_PERSONA_JURIDICA = "270";
export const OTRO_TIPO_INTERIOR = "259";

export const OTRO_CONDICION_TITULAR = "59";
export const OTRO_FORMA_ADQUISICION = "116";
export const OTRO_PREDIO_CATASTRAL = "144";
export const OTRO_CONDICION_DECLARANTE = "52";

export const OTRO_DOCUMENTO_PRESENTADO = "86";
export const OTRO_CONDICION_CONDUCTOR = "46";
export const ID_DEPARTAMENTO_SISTEMA = "23"; // TACNA
export const ID_PROVINCIA_SISTEMA = "2301"; // TACNA

export const OTRO_CONDICION_NUMERICA = "42";
export const IGUAL_UBICACION_DOMICILIAN = "315";
export const OTRO_UBICACION_DOMICILIAN = "316";

export const TIPO_DOCUMENTO_RUC = "570";
